export const checkProductionMode = () => {
  return process.env.REACT_APP_STAGE === 'live';
};
